import React from "react";
import { Menu } from "antd";
import { NavLink, useRouteMatch } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import propTypes from "prop-types";

const { SubMenu } = Menu;

const MenuItemsPanel = ({ darkMode, toggleCollapsed, topMenu, events }) => {
  const { path } = useRouteMatch();

  const pathName = window.location.pathname;
  const pathArray = pathName.split(path);
  const mainPath = pathArray[1];
  const mainPathSplit = mainPath.split("/");

  const [openKeys, setOpenKeys] = React.useState(
    !topMenu
      ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : "dashboard"}`]
      : []
  );

  const onOpenChange = (keys) => {
    setOpenKeys(
      keys[keys.length - 1] !== "recharts"
        ? [keys.length && keys[keys.length - 1]]
        : keys
    );
  };

  const onClick = (item) => {
    if (item.keyPath.length === 1) setOpenKeys([]);
  };
  // modeChangeDark();
  // modeChangeTopNav();
  return (
    <Menu
      onOpenChange={onOpenChange}
      onClick={onClick}
      mode={!topMenu || window.innerWidth <= 991 ? "inline" : "horizontal"}
      theme={darkMode && "dark"}
      // // eslint-disable-next-line no-nested-ternary
      defaultSelectedKeys={
        !topMenu
          ? [
              `${
                mainPathSplit.length === 1
                  ? "home"
                  : mainPathSplit.length === 2
                  ? mainPathSplit[1]
                  : mainPathSplit[2]
              }`,
            ]
          : []
      }
      defaultOpenKeys={
        !topMenu
          ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : "dashboard"}`]
          : []
      }
      overflowedIndicator={<FeatherIcon icon="more-vertical" />}
      openKeys={openKeys}
    >
      <SubMenu
        /*onClick={ ()=> { history.push(`${path}/users/dataTable`);toggleCollapsed() } }*/ key="manuales"
        icon={!topMenu && <FeatherIcon icon="file-text" />}
        title="Manuales"
      >
        <Menu.Item key="dataTable">
          <NavLink
            onClick={toggleCollapsed}
            to={`${path}/manuals/crud/manuals-view`}
          >
            Manuales
          </NavLink>
        </Menu.Item>
      </SubMenu>
      <SubMenu
        /*onClick={ ()=> { history.push(`${path}/users/dataTable`);toggleCollapsed() } }*/ key="boletines"
        icon={!topMenu && <FeatherIcon icon="file" />}
        title="Boletines"
      >
        <Menu.Item key="dataTable">
          <NavLink
            onClick={toggleCollapsed}
            to={`${path}/newsletter/crud/newsletter-view`}
          >
            Tabla Boletines
          </NavLink>
        </Menu.Item>
      </SubMenu>
    </Menu>
  );
};

MenuItemsPanel.propTypes = {
  darkMode: propTypes.bool,
  topMenu: propTypes.bool,
  toggleCollapsed: propTypes.func,
  events: propTypes.object,
};

export default MenuItemsPanel;
